import { memo } from "react";
import type { ActiveInspectionRegister } from "../../InspectionsLists.d";
import { useDate } from "@/hooks/use-date/useDate";
import circleArrow from "@/assets/images/inspections-table/circleArrow.svg";
import { Link } from "react-router-dom";
import { BASE_URL } from "@/assets/constants/constants";
import PhasePill from "../../phase-pill/PhasePill";

export interface ActivedInspectionsProps {
  tableData: ActiveInspectionRegister[];
}

const ActivedInspections = ({ tableData }: ActivedInspectionsProps) => {
  const { formatDate, getDaysSince } = useDate();

  return tableData?.map((register: ActiveInspectionRegister, index: number) => (
    <tr
      data-testid="active-inspection-row"
      key={`tr-${index}`}
      className={`${index % 2 === 0 ? "table-odd-row" : "table-even-row"}${
        index === tableData.length - 1 ? " last-row" : ""
      } h-16 border-b border-b-ib-gray-lightest text-[14px] leading-[16px] text-ib-gray-darkest tracking-neg-1`}
    >
      <td className="h-full left-cell"></td>
      <td className="h-16 p-3 flex flex-row justify-center gap-x-2 items-center">
        <span>{formatDate(register.createdAt)}</span>
        <span className="font-ib-bold">{getDaysSince(register.createdAt)}</span>
      </td>
      <td className="p-3 text-center">{register.engineName}</td>
      <td className="p-3 text-center">{register.snStand}</td>
      <td className="p-3 text-center">{register.esnIn}</td>
      <td className="p-3 text-center">{register.colour}</td>
      <td className="px-3 py-2">
        <div className="w- full flex flex-row justify-start gap-x-2 items-center">
          <span>{formatDate(register.phase?.date)}</span>
          <PhasePill phaseName={register.phase.name} />
        </div>
      </td>
      <td className="px-3 py-2 right-cell">
        <div className="w- full flex flex-row justify-end items-center gap-x-6">
          <Link to={`${BASE_URL}/${register.id}`}>
            <button data-testid="open-inspection-button" value={register.id}>
              <img className="h-[20px] min-w-[20px]" src={circleArrow} />
            </button>
          </Link>
        </div>
      </td>
    </tr>
  ));
};

export default memo(ActivedInspections);
